import React from 'react';
import { Button } from '@commons/button/Button';
import cx from 'classnames';
import * as styles from './color-button.module.scss';

export const ColorButton = ({ id, className, label, onClick, href }) => {
  return (
    <Button
      key={id}
      className={cx(styles.button, className)}
      onClick={onClick}
      href={href}
      label={label}
      rel="nofollow"
    >
    </Button>
  );
};
